module.exports = __webpack_public_path__ + "static/media/banner_mobil.cf486ce7.png";